<div class="title slds-size_1-of-1">
  <span class="slds-icon_container slds-icon_container_circle {{ to['iconClass'] }}">
    <svg class="slds-icon slds-icon_small" aria-hidden="true">
      <use [attr.xlink:href]="'/assets/icons/standard-sprite/svg/symbols.svg#' + to['iconSvg']"></use>
    </svg>
  </span>
  {{ to.label }}
</div>
